import { gql } from '@memberjunction/graphql-dataprovider';

/** OEPFileResolver (apps/MJAPI/src/resolvers/OEPFileResolver.ts; apps/MJAPI/schema.graphql). */
export const OEP_REQUEST_UPLOAD = gql`mutation OEPRequestUpload($presentationId: String!, $kind: String!, $fileName: String!, $contentType: String!, $sizeBytes: Float!) {
  oepRequestUpload(presentationId: $presentationId, kind: $kind, fileName: $fileName, contentType: $contentType, sizeBytes: $sizeBytes) { fileId uploadUrl } }`;
export const OEP_CONFIRM_UPLOAD = gql`mutation OEPConfirmUpload($fileId: String!) { oepConfirmUpload(fileId: $fileId) { fileId name status } }`;
export const OEP_DOWNLOAD_URL = gql`mutation OEPFileDownloadUrl($fileId: String!) { oepFileDownloadUrl(fileId: $fileId) }`;

/**
 * MJ's own RunAction mutation (MJServer ActionResolver), with the same selection set
 * GraphQLActionClient sends. Issued directly rather than through GraphQLActionClient because
 * that client's result mapping loses exactly what OEP needs (graphql-dataprovider 5.51
 * dist/index.mjs, class GraphQLActionClient): processActionResult drops the queried
 * `ResultCode` and returns the caller's INPUT params as `Params` (outputs only arrive, parsed,
 * as `Result`), and handleActionError flattens a thrown GraphQL error to a
 * "Error: …" string, erasing `extensions.code` (FORBIDDEN from the Action Authorization guard).
 */
export const OEP_RUN_ACTION = gql`mutation OEPRunAction($input: RunActionInput!) {
  RunAction(input: $input) { Success Message ResultCode ResultData } }`;
